import React from 'react';
import {
  TabsUnstyled,
  TabUnstyled,
  TabsListUnstyled,
  buttonUnstyledClasses,
  tabUnstyledClasses
} from '@mui/base';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import palette from '../theme/palette';

const Tab = styled(TabUnstyled)`
  font-family: IBM Plex Sans, sans-serif;
  color: black;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: transparent;
  width: 100%;
  padding: 12px 16px;
  margin: 6px 6px;
  border: none;
  border-radius: 5px;
  display: flex;
  justify-content: center;

  &:focus {
    border-radius: 3px;
    outline: 2px solid white;
    outline-offset: 2px;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: white;
    color: black;
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabsList = styled(TabsListUnstyled)`
  min-width: 320px;
  background-color: ${palette.secondary.lighter};
  border-radius: 8px;
  // margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
`;

export default function CustomizeTabs({ options = [], onChange, value = 0 }) {
  return (
    <TabsUnstyled defaultValue={0} value={value}>
      <TabsList>
        {options.map((o, i) => (
          <Tab onClick={() => onChange(i)} key={i}>
            {o.title}
          </Tab>
        ))}
      </TabsList>
    </TabsUnstyled>
  );
}

CustomizeTabs.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.number
};
